<div class="modal" role="dialog" [attr.aria-modal]="true" aria-labelledby="dialogTitle" cdkTrapFocus>
  <div class="modal__backdrop">
    @if (blockModal) {
      <div class="modal__block" #modalContent attr.id="modal-{{id}}">
        @if (opened()) {
          @if (!systemModal && (titleExists || topAction)) {
            <div class="modal__header" [ngClass]="{ 'justify-end': !titleExists }">
              @if (titleExists) {
                <h2 tabindex="-1" #titleRef id="dialogTitle" attr.aria-label="{{ modalTitle }}">{{ modalTitle }}</h2>
              }
              @if (topAction) {
                <button attr.aria-label="{{ 'button.close' | translate }}" htm-button theme="icon"
                  (click)="modalService.close(id)"
                  [attr.data-test-id]="'modal-top-close-button-' + id">
                  <icon glyph="x" size="medium"></icon>
                </button>
              }
            </div>
          }
          <div class="modal-content">
            <ng-template [ngTemplateOutlet]="templateRef"></ng-template>
          </div>
          @if (bottomAction) {
            <div class="modal__footer">
              <button (blur)="modalService.focusLock()" htm-button theme="plain"
                attr.aria-label="{{ 'button.close' | translate }}"
                [attr.data-test-id]="'modal-bottom-close-button-' + id"
                (click)="modalService.close(id)">{{ 'button.close' | translate }}
              </button>
            </div>
          }
        }
      </div>
    } @else {
      <div class="modal__regular" #modalContent attr.id="modal-{{id}}" tabindex="0">
        @if (opened()) {
          @if (topAction) {
            <div class="modal__header" [ngClass]="{ 'justify-end': topAction }" >
              @if (topAction) {
                <button class="white" attr.aria-label="{{ 'button.close' | translate }}" htm-button theme="icon"
                  (click)="modalService.close(id)"
                  [attr.data-test-id]="'modal-top-close-button-' + id">
                  <icon glyph="x" size="medium"></icon>
                </button>
              }
            </div>
          }
          <ng-template [ngTemplateOutlet]="templateRef"></ng-template>
        }
      </div>
    }
  </div>
</div>
